// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SUtW","top":"styles_top__1DdZk","left":"styles_left__2Re68","description":"styles_description__1e15X"};